import { normalizeOptionalBoolean } from './contract-term.utils';

export interface InventoryCreditNoteData {
  inventory_credit_note?: unknown;
  inventory_credit_note_stamped?: unknown;
  credit_amount?: unknown;
  cfdixml?: unknown;
}

export function isInventoryCreditNote(note: InventoryCreditNoteData | null | undefined): boolean {
  return normalizeOptionalBoolean(note?.inventory_credit_note) === true;
}

export function inventoryCreditNoteStamp(note: InventoryCreditNoteData | null | undefined): boolean | null {
  return isInventoryCreditNote(note) ? normalizeOptionalBoolean(note?.inventory_credit_note_stamped) ?? null : null;
}

export function inventoryCreditNoteAmount(note: InventoryCreditNoteData | null | undefined): number | null {
  if (!isInventoryCreditNote(note)) return null;
  const value = note?.credit_amount;
  if (typeof value !== 'number' && typeof value !== 'string') return null;
  if (typeof value === 'string' && !value.trim()) return null;
  const amount = Number(value);
  return Number.isFinite(amount) && amount >= 0 ? amount : null;
}

export function hasCreditNoteXml(note: InventoryCreditNoteData | null | undefined): boolean {
  return typeof note?.cfdixml === 'string' && note.cfdixml.trim().length > 0;
}
